// TODO: create GraphQL enum for ConnectionEnvironment.
export enum ConnectionEnvironment {
  BRAZIL = 76,
  USA = 0 | 840,
  TRAINING = 9999,
}

export enum EnvironmentMode {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
}

export enum PageTitle {
  HOME = 'home',
  DONOR_SCHEDULING = 'donorScheduling',
  CHUTE_SCHEDULER = 'chuteScheduler',
  FERTILIZATIONS = 'fertilizations',
  STRIPPING = 'stripping',
  OPU_SEARCH = 'opuSearch',
  CHUTESIDE = 'aspiration',
  SEMEN_PULL = 'semenPull',
  SHIPPING = 'shipping',
  SHIPMENT = 'shipment',
  CALF_ENTRY = 'calfEntry',
  DEVELOPER = 'developer',
  LEGACY_APPS = 'legacyApps',
  FRESH_SHIPMENT = 'freshShipment',
  FREEZE = 'freeze',
}

export enum LOAD_DONOR_PARTNERS_OPTION_VALUES {
  YES = 100000001,
  NO = 100000000,
}

export enum BILL_ACCOUNT_CANING_OPTION_VALUES {
  NO_CHANGES = 100000000,
  GROUPS_OF_THREE = 100000001,
  ODDS_AND_EVENS = 100000002,
}

export enum FREEZE_OPTION_VALUES {
  FREEZE = 100000001,
  FREEZE_ONLY = 100000002,
  FREEZE_1 = 100000000,
  FREEZE_2 = 100000003,
  FREEZE_3 = 100000004,
  FREEZE_4 = 100000005,
  FREEZE_5 = 100000006,
  FREEZE_6 = 100000007,
  Freeze_6 = 100000008,
  FREEZE_7 = 100000008,
  FREEZE_8 = 100000009,
  FREEZE_9 = 100000010,
  FREEZE_10 = 100000011,
}

export enum SEMEN_TYPE_OPTION_VALUES {
  CONV = 100000000,
  SF_F = 100000001,
  SF_M = 100000002,
  RS_F = 100000003,
  RS_M = 100000004,
}

export enum EXPORT_OPTION_VALUES {
  NO = 0,
  YES_NON_EU = 1,
  EU = 2,
  AU = 3,
  UK = 4,
  SA = 5,
}

export enum PREGNANT_OPTION_VALUES {
  NO = 100000000,
  YES = 100000001,
}

export enum SHIP_OPTION_VALUES {
  SHIP = 100000000,
  SHIP_ALL = 100000001,
  SHIP_DAY_5 = 100000002,
  SHIP_STRAW_ALL = 100000003,
  SHIP_STRAW = 100000004,
}

export enum TRANSFER_OPTION_VALUES {
  TRANSFER_ALL = 100000001,
  TRANSFER_LOW = 100000002,
  TRANSFER_1 = 100000003,
  TRANSFER_2 = 100000004,
  TRANSFER_3 = 100000005,
  TRANSFER_4 = 100000006,
  TRANSFER_5 = 100000007,
  TRANSFER_6 = 100000008,
  TRANSFER_7 = 100000009,
  TRANSFER_8 = 100000010,
  TRANSFER_9 = 100000011,
  TRANSFER_10 = 100000012,
}

export enum NON_EU_COUNTRY_VALUES {
  ARGENTINA = 100000000,
  AUSTRALIA = 100000001,
  BOLIVIA = 100000002,
  BRAZIL = 100000003,
  CANADA = 100000004,
  CHINA = 100000005,
  COLOMBIA = 100000006,
  COSTA_RICA = 100000007,
  ECUADOR = 100000008,
  GUATEMALA = 100000009,
  HONDURAS = 100000010,
  JAPAN = 100000011,
  KENYA = 100000012,
  MEXICO = 100000013,
  NEW_ZEALAND = 100000014,
  PANAMA = 100000015,
  PARAGUAY = 100000016,
  PHILIPPINES = 100000017,
  UNITED_KINGDOM = 100000018,
  OTHER = 100000019,
}
